const infoTrigger = document.querySelector('.metafield-info--trigger');
if (infoTrigger) {
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (target.classList.contains('metafield-info--trigger') && !target.closest('.metafield-table__table-row-heading.info--active')) {
      // Remove the active class to make sure only one into section is open at a time
      document.querySelector('.metafield-table__table-row-heading.info--active')?.classList.remove('info--active');

      target.closest('.metafield-table__table-row-heading').classList.add('info--active');
    } else if (!target.classList.contains('metafield-info-description')) {
      document.querySelector('.metafield-table__table-row-heading.info--active')?.classList.remove('info--active');
    }
  });
}